import { Link } from 'react-router-dom';
import { Mail } from 'lucide-react';

export default function Footer() {
  return (
    <footer className="site-footer">
      <div className="site-footer-inner">
        <div className="site-footer-brand">
          <Link to="/" className="site-footer-logo" aria-label="ChessLytics home">
            <span className="site-footer-pawn" aria-hidden>♟</span>
            <span className="site-footer-wordmark">ChessLytics</span>
          </Link>
          <p className="site-footer-tagline">
            Chess analytics for players who want to understand their game.
          </p>
        </div>

        <div className="site-footer-contact">
          <a href="mailto:EdwardL9039@gmail.com" className="site-footer-contact-link">
            <Mail size={14} aria-hidden />
            EdwardL9039@gmail.com
          </a>
          <a
            href="https://www.chess.com/member/EdwardL903"
            target="_blank"
            rel="noopener noreferrer"
            className="site-footer-contact-link"
          >
            <span aria-hidden>♟</span>
            Chess.com @EdwardL903
          </a>
          <Link to="/about" className="site-footer-contact-link">
            About
          </Link>
        </div>
      </div>

      <div className="site-footer-bottom">
        <span>© {new Date().getFullYear()} Edward Lai. All rights reserved.</span>
      </div>
    </footer>
  );
}
